import * as React from 'react';
import {View} from '@packages/systems/spring';

/**
 * A higher-order component that wraps an icon (SVG) component for
 * rendering the 64x64 AddPanel icons.
 */
export const wrapAddPanelIcon = (Icon: React.ComponentType<any>) => {
  const IconComponent = React.forwardRef<any, any>((props, ref) => {
    return (
      <View color="$textPrimary">
        <Icon
          data-component="add-panel-icon"
          style={{marginTop: -14, marginBottom: -14}}
          {...props}
          ref={ref}
          size={64}
        />
      </View>
    );
  });

  return IconComponent;
};
